import { FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { Icon } from "@deliverr/ui/lib-esm/Icon";
import React from "react";

export const Spinner: React.FC<Pick<FontAwesomeIconProps, "size">> = ({
  size,
}) => {
  return (
    <Icon type="circle-notch" size={size || "5x"} spin className="text-text" />
  );
};
